import React from "react";

export default function VideoIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#currentColor" clipPath="url(#a)">
        <path d="M12 22.582a10.5 10.5 0 1 1 0-21 10.5 10.5 0 0 1 0 21Zm0 1.5a12 12 0 1 0 0-24 12 12 0 0 0 0 24Z" />
        <path d="M9.406 7.665a.75.75 0 0 1 .78.057l5.25 3.75a.75.75 0 0 1 0 1.221l-5.25 3.75A.75.75 0 0 1 9 15.833v-7.5a.75.75 0 0 1 .406-.668Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .082h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
